import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserHeaderComponent } from './user-header/user-header.component';
import { UserFooterComponent } from './user-footer/user-footer.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BasicComponent } from './basic/basic.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentsComponent } from './documents/documents.component';
import { UploadDocumentComponent } from './upload-document/upload-document.component';
import { DownloadTaxReturnComponent } from './download-tax-return/download-tax-return.component';
import { MakePaymentComponent } from './make-payment/make-payment.component';
import { ContentDisclosureComponent } from './content-disclosure/content-disclosure.component';
import { ReferDashboardComponent } from './refer-dashboard/refer-dashboard.component';
import { ChangepwdComponent } from './changepwd/changepwd.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';

import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { NgxSpinnerModule } from "ngx-spinner";
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [UserHeaderComponent, UserFooterComponent, DashboardComponent, BasicComponent, DocumentsComponent, UploadDocumentComponent, DownloadTaxReturnComponent, MakePaymentComponent, ContentDisclosureComponent, ReferDashboardComponent, ChangepwdComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    ShowHidePasswordModule,
    NgxSpinnerModule,
    RouterModule.forRoot([])
  ],
  exports: [UserHeaderComponent, UserFooterComponent],
})
export class UserModule { }
